export function asyncAjax( $, type, url, action, nonce, data = {} ) {
	data.action = action;
	data._ajax_nonce = nonce; // eslint-disable-line camelcase
	return new Promise( function( resolve, reject ) {
		$.ajax( {
			type,
			dataType: 'json',
			url, // eslint-disable-line no-undef
			data,
			success( res ) {
				console.log( res ); // eslint-disable-line no-console
				resolve( res );
			},
			error( e ) {
				console.error( e.statusText ); // eslint-disable-line no-console
				reject( e );
			},
		} );
	} );
}

/**
 * Async call to a route
 *
 * @param {string} url   URL to fetch.
 * @param {string} nonce Nonce to pass
 * @param {Object} data  Data to send
 * @return {Promise} Promise object
 */
export async function asyncCallRoutePost( url, nonce, data = {} ) {
	const response = await fetch( url, {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': nonce,
		},
		body: JSON.stringify( {
			_wpnonce: nonce,
			...data,
		} ), // body data type must match "Content-Type" header
	} );

	return await response.json();
}
